import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { CustomerAddressEndpoint } from '@dato-proxy/endpoints/customeraddress.endpoint';
import { CustomerAddress } from '@dato-proxy/entities/customeraddress.entity';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { Component } from '@angular/core';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { EnumCustomerAddressTypes, EnumSystemTypes } from '@dato-proxy/enums';
import { State as StateEntity } from '@dato-proxy/entities/state.entity';
import { Globals } from 'projects/dato/_globals';

class State extends BaseState {
    IsReadOnlyIsDefault = false;
    StatesDataSource: StateEntity[] = [];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-customer-address',
    templateUrl: './customer-address.component.html',
    styleUrls: ['./customer-address.component.scss']
})
export class CustomerAddressComponent extends BasePageCRUDComponent<CustomerAddress, State, CustomerAddressEndpoint> {

    constructor(A: ServiceBagService,
        protected customerAddressEndpoint: CustomerAddressEndpoint) {
        super(A, 'CustomerAddressComponent', CustomerAddress, State, customerAddressEndpoint);
    }
    public IsLandlord() { return Globals.SystemOption && Globals.SystemOption.SystemType === EnumSystemTypes.Landlord; }

    override OnIsDirtyDisabled() { return true };

    override OnEntityLoaded() {
        if (this.Entity.Type === EnumCustomerAddressTypes.Bill && this.Entity.IsDefaultBilling) { this.State.IsReadOnlyIsDefault = true; }
        if (this.Entity.Type === EnumCustomerAddressTypes.Ship && this.Entity.IsDefaultShipment) { this.State.IsReadOnlyIsDefault = true; }

        this.LoadStatesDataSource();
    }

    override OnInitComponent() {
        if (this.QueryParams.Type) { this.Entity.Type = this.QueryParams.Type; }

        this.DataSources['Countries'] = new DataSourceCustomAction(() => this.customerAddressEndpoint.GetCountries());
    }

    override OnEntitySaved() {
        this.ClosePage();
    }

    OnCountryChanged(e) {
        if (e.previousValue) { this.Entity.State = null; }

        this.LoadStatesDataSource();
    }

    private LoadStatesDataSource() {
        this.Do(this.customerAddressEndpoint.GetStatesByCountryCode(this.Entity.Country), false, (response) => {
            this.State.StatesDataSource = response.Entities;
        });
    }

}
